(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
        const menus = document.querySelectorAll('.footer-menu-container-accordion');
        menus.forEach(menu => {
            menu.querySelector('.footer-menu-title-wrapper').addEventListener('click', function() {
                if (menu.dataset.isModalOpen === 'false') {
                    menu.dataset.isModalOpen = 'true';
                } else {
                    menu.dataset.isModalOpen = 'false';
                }
            });
        });
    });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    const buttons = document.querySelectorAll('.product-card__item-add-to-cart');
  
  function isBundlePage() {
    return document.querySelector('.bundle-sticky-box__container') !== null || 
           window.location.pathname.includes('bundle') ||
           (window.addToBundle && typeof window.addToBundle === 'function');
  }
  
  buttons.forEach(button => {
    button.addEventListener('click', async function(event) {
      event.preventDefault(); 
      event.stopPropagation();
      if (button.hasAttribute('loading') || button.getAttribute('available') === 'false') return;

      const variantId = button.dataset.variantId;
      const soldOut = document.querySelector(`.product-card__item-sold-out[data-variant-id="${variantId}"]`);
      button.setAttribute('disabled', '');
      button.setAttribute('loading', '');

      if (isBundlePage() && window.addToBundle) {
        try {
          const productData = {
            id: variantId,
            title: button.dataset.productTitle || '',
            price: parseFloat(button.dataset.productPrice) || 0,
            compare_at_price: parseFloat(button.dataset.productComparePrice) || 0,
            image: button.dataset.productImage || '',
            quantity: 1,
            stock: parseInt(button.dataset.productStock) || 999
          };
          
          window.addToBundle(productData);
          
          // Feedback visual
          const originalText = button.querySelector('span').textContent;
          button.querySelector('span').textContent = 'Added!';
          
          setTimeout(() => {
            button.querySelector('span').textContent = originalText;
            button.removeAttribute('disabled');
            button.removeAttribute('loading');
          }, 1500);
        } catch (error) {
          console.error('Error adding to bundle:', error);
          button.removeAttribute('disabled');
          button.removeAttribute('loading');
        }
        return;
      }

      // Comportamento normal: adiciona ao carrinho
      try {
        const response = await $.ajax({
            url: window.Shopify.routes.root + 'cart/add.js',
            method: 'post',
            dataType: 'json',
            data: {
              id: variantId,
              quantity: 1
            },
      });
      await CartAPI.openCartDrawer();

      } catch (error) {
        console.error(error);
        
        if (soldOut) {
          soldOut.innerHTML = error.responseJSON.message;
          soldOut.style.left = '0';


          setTimeout(() => {  
            soldOut.style.left = '-100%';
          }, 2000);
        } else {
          console.log('Sold out not found');
        }
      } finally {
        setTimeout(() => {
          button.removeAttribute('disabled');
          button.removeAttribute('loading');
        }, 800); 
      }

    });
  });
  } catch(e) { console.error(e); }
})();

})();
